import config from 'config';
import API from './http';

const company = {
  async get() {
    try {
      const res = await API.get(`${config.CORP_API_URL}/company`);
      return res.data;
    } catch (err) {
      console.error('Error getting company', err);
      throw err;
    }
  },
  async update(data) {
    try {
      const res = await API.put(`${config.CORP_API_URL}/company`, data);
      return res.data;
    } catch (err) {
      console.error('Error updating company', err);
      throw err;
    }
  },
  async getAddress() {
    try {
      const res = await API.get(`${config.ZUL_API_URL}/user/address`);
      return res.data;
    } catch (err) {
      console.error('Error getting company address', err);
      throw err;
    }
  },
  async updateAddress(data) {
    try {
      const res = await API.post(`${config.ZUL_API_URL}/user/address`, data);
      return res.data;
    } catch (err) {
      console.error('Error updating company address', err);
      throw err;
    }
  },
};

export default company;
